import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderHistoryRoutingModule } from './order-history-routing.module';
import { OrderHistoryComponent } from './order-history.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ControlsModule, FormFieldModule } from 'src/app/shared';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReusableModule } from 'src/app/shared/reusable/reusable.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { MatSelectModule } from '@angular/material/select';
import { OrderItemsComponent } from './order-items/order-items.component';
import { UpdateOrderStatusComponent } from './update-order-status/update-order-status.component';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [
    OrderHistoryComponent,
    OrderItemsComponent,
    UpdateOrderStatusComponent
  ],
  imports: [
    CommonModule,
    OrderHistoryRoutingModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    FormFieldModule,
    ControlsModule,
    NgbModule,
    ReusableModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    BsDropdownModule.forRoot(),
    MatSelectModule,
    MatTooltipModule,
  ]
})
export class OrderHistoryModule { }
